<script>
    import Button from '../../../components/buttons/Button';

    export default {
        components: {
            Button
        },
        props: {
            workflows: {
                type: Array,
                default: [],
                required: true,
            },
        },
        data() {
            return {             
                taskActionButtonClicked: []
            }
        },
        methods: {
            showDetails(id) {
                if(this.$refs['details-' + id][0].style.display.length == 0) {
                    this.$refs['details-' + id][0].style.display = 'none'
                    this.$refs['icon-id-' + id][0].innerHTML = '<i class="mdi mdi-chevron-right"></i>'
                } else {
                    var elements = document.getElementsByClassName('all_details')
                    var allIconElements = document.getElementsByClassName('all-icons')
                    for (var i = 0; i < elements.length; i++) {
                        elements[i].style.display = 'none'
                        allIconElements[i].innerHTML = '<i class="mdi mdi-chevron-right"></i>'
                    }
                    this.$refs['details-' + id][0].style.display = ''
                    this.$refs['icon-id-' + id][0].innerHTML = '<i class="mdi mdi-chevron-down"></i>'
                }
            },
            taskActionButtonClick(index, routeOrURL, linkType) {
                this.taskActionButtonClicked.push(index)
                if(linkType === 'Route') {
                    window.location.href = route(routeOrURL)
                } else {
                    window.location.href = routeOrURL
                }         
            }
        },
        computed: {
            userTypeAbbr() {
                return this.$page.props.auth.user.user_type_abbr;
            },
            userID() {
				return this.$page.props.auth.user.user_id;
			},
            subTableColspan() {
				return this.$page.props.auth.user.user_type_abbr == 'sb' ? 6 : 5;
			},
        },
    }
</script>

<template>
    <div class="card">
        <div class="card-body">
            <div class="table-responsive">
                <table class="table align-middle table-nowrap table-hover">
                    <thead class="table-light">
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Name</th>
                            <th scope="col" v-if="userTypeAbbr == 'sb'">Assigner</th>
                            <th scope="col">Workflow Assigned</th>
                            <th scope="col">Progress</th>
                            <th scope="col">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template  v-for="(item, index) in workflows">
                            <tr :key="index" @click="showDetails(index)" class="main-tr">
                                <td :ref="'icon-id-' + index" class="all-icons"><i class="mdi mdi-chevron-right"></i></td>
                                <td>
                                    <div class="d-flex">
                                        <div class="flex-shrink-0 align-self-center me-3">
                                            <div v-if="item.assignee_photo.length == 0" class="avatar-xs">
                                                <span class="avatar-title rounded-circle">
                                                    {{ item.assigned_to.name | onlyFirstLetter }}
                                                </span>
                                            </div>
                                            <img v-else :src="item.assignee_photo" class="rounded-circle avatar-xs" alt="" />
                                        </div>
                                        <div class="flex-grow-1 overflow-hidden">
                                            <h5 class="font-size-14 mb-1"><a href="javascript: void(0);" class="text-dark">{{ item.assigned_to.name }}</a></h5>
                                            <p class="text-muted mb-0">{{ item.assigned_to.email }}</p>
                                        </div>
                                    </div>
                                </td>
                                <td v-if="userTypeAbbr == 'sb'">
                                    <div class="d-flex">
                                        <div class="flex-shrink-0 align-self-center me-3">
                                            <div v-if="item.assigner_photo.length == 0" class="avatar-xs">
                                                <span class="avatar-title rounded-circle">
                                                    {{ item.assigned_by.name | onlyFirstLetter }}
                                                </span>
                                            </div>
                                            <img v-else :src="item.assigner_photo" class="rounded-circle avatar-xs" alt="" />
                                        </div>
                                        <div class="flex-grow-1 overflow-hidden">
                                            <h5 class="font-size-14 mb-1"><a href="javascript: void(0);" class="text-dark">{{ item.assigned_by.name }}</a></h5>
                                            <p class="text-muted mb-0">{{ item.assigned_by.email }}</p>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    {{ item.name }}
                                </td>
                                <td>
                                    <span class="badge" :class="{'badge-soft-success': item.total_completed_tasks, 'badge-soft-danger': !item.total_completed_tasks}">
                                        {{ item.total_completed_tasks }} / {{ item.tasks.length }} Tasks
                                    </span>
                                </td>
                                <td>
                                    <span class="badge" :class="item.mainTableStatusColor">
                                        {{ item.mainTableStatusText }}
                                    </span>
                                </td>
                            </tr>                            
                            <tr :ref="'details-' + index" class="all_details" style="display:none;">
                                <td :colspan="subTableColspan">
                                    <table class="table mb-0">
                                        <thead>
                                            <tr>
                                            <th scope="col">Task</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(taskItem, taskIndex) in item.tasks" :key="taskIndex">
                                                <th scope="row">
                                                    {{ taskItem.name }}
                                                </th>
                                                <td>
                                                    <span :class="taskItem.statusColor">
                                                        {{ taskItem.statusName }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <b-button
                                                        v-if="((taskItem.task_status.id === 1 || taskItem.task_status.id === 2) && taskItem.task_owner.owner_id == userID && (taskItem.button_color !== null))"
                                                        @click="taskActionButtonClick(item.id + '_' + taskItem.id, taskItem.actual_route_or_url, taskItem.link_type)"
                                                        type="button" 
                                                        class="btn btn-success"
                                                        :disabled="taskItem.statusName === 'Unavailable' || taskActionButtonClicked.includes(item.id + '_' + taskItem.id)"
                                                        :title="taskItem.name"
                                                        :key="item.id + '_' + taskItem.id"
                                                        >
                                                        <template v-if="taskActionButtonClicked.includes(item.id + '_' + taskItem.id)">
                                                            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>Loading
                                                        </template>
                                                        <template v-else>
                                                            {{ taskItem.button_text }}
                                                        </template>
                                                    </b-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .invisible{
        display: none;
    }

    .main-tr:hover {
        cursor: pointer;
    }
</style>
